import { render, staticRenderFns } from "./ReminderTasks.vue?vue&type=template&id=082c28cd&scoped=true&"
import script from "./ReminderTasks.vue?vue&type=script&lang=js&"
export * from "./ReminderTasks.vue?vue&type=script&lang=js&"
import style0 from "./ReminderTasks.vue?vue&type=style&index=0&id=082c28cd&lang=scss&scoped=true&"
import style1 from "./ReminderTasks.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082c28cd",
  null
  
)

export default component.exports